import React from "react";
import { Send } from "lucide-react";
import { Button } from "../../ui";

interface ChatSendButtonProps {
  disabled: boolean;
  loading: boolean;
}

// send control for the chat composer. on phones it collapses to a compact square icon button
// so it can't crowd the textarea or bleed past the screen edge; on wider screens it shows the
// "send" label. mirrors the mic button's mobile footprint for a symmetric composer.
export function ChatSendButton({ disabled, loading }: ChatSendButtonProps) {
  return (
    <Button
      type="submit"
      size="sm"
      disabled={disabled}
      loading={loading}
      className="shrink-0 max-[700px]:w-9 max-[700px]:px-0"
      aria-label="send message"
    >
      {!loading && <Send className="w-4 h-4 min-[701px]:hidden" aria-hidden="true" />}
      <span className="max-[700px]:hidden">send</span>
    </Button>
  );
}
